import { useMemo } from 'react'

import { getAccountId, getUserId } from '~/helpers'

const STORAGE_KEY_PREFIX = 'vtexads:rm:cards'
const STORAGE_VERSION = 'v3'

export const useCardVisibilityStorageKey = (screenName: string) => {
  const accountId = useMemo(() => getAccountId(), [])
  const userId = useMemo(() => getUserId(), [])

  return useMemo(() => {
    if (!accountId || !userId) return null
    return `${STORAGE_KEY_PREFIX}:${STORAGE_VERSION}:${screenName}:${accountId}:${userId}`
  }, [screenName, accountId, userId])
}
